import React from 'react';
import feather from 'feather-icons';
import PropTypes from 'prop-types';

import InlineSVG from './InlineSVG';

import './Icon.css';

const Icon = React.forwardRef(({
  i,
  size,
  children,
  className,
  ...rest
}, ref) => {
  if (!feather.icons[i]) {
    return null;
  }

  const svg = feather.icons[i].toSvg({
    width: size,
    height: size,
  });

  return (
    <i ref={ref} className={`icon ${className}`} {...rest}>
      <InlineSVG src={svg} />
      {children}
    </i>
  );
});

Icon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  children: PropTypes.element,
  i: PropTypes.string.isRequired,
};

Icon.defaultProps = {
  className: '',
  size: 24,
  children: null,
};

export default Icon;
